// extracted by mini-css-extract-plugin
export default {"questionBlockContainer":"QuestionBlock_questionBlockContainer__hvBD9","questionText":"QuestionBlock_questionText__E3fAF","questionButtons":"QuestionBlock_questionButtons__GPmsF"};